/**
* StartGameCommand.js
* 
* Created on Oct 17, 2013, 11:52:42 AM
*
* @author Javier Quevedo-Fernandez for Ranj
**/
import AbstractCommand from '../../core/application/AbstractCommand';
import ScenarioCommandEvent from "../scenario/controller/ScenarioCommandEvent";
import SaveGameService from "../../app/save-game/controller/SaveGameService";
import SaveGameModel from "../../app/save-game/model/SaveGameModel";
import SaveGameEvent from "../../app/save-game/events/SaveGameEvent";
import SystemMessageBuilder from "../../core/system-message/controller/SystemMessageBuilder";
import RevisableLanguagePack from "../../../../lib/html5-software-library/src/ranj/language/RevisableLanguagePack";
import SkinKeyRegistry from "../../core/ui/SkinKeyRegistry";
import AnimationFactory from "../../../../lib/html5-software-library/src/ranj/ui/animation/AnimationFactory";
import AnimationOptions from "../../../../lib/html5-software-library/src/ranj/ui/animation/AnimationOptions";
import TrackString from '../../analytics/TrackString';
import TrackScreenString from '../../analytics/TrackScreenString';

export default class StartGameCommand extends AbstractCommand {
    /**
     * @constructor
     * @param {soma.EventDispatcher} dispatcher 
     * @param {SaveGameService} saveGameService 
     * @param {RevisableLanguagePack} languagePack 
     * @param {SaveGameModel} saveGameModel 
     */
    constructor(dispatcher, saveGameService, languagePack, saveGameModel) {
        super(dispatcher);
        this._saveGameService = saveGameService;
        this._languagePack = languagePack;
        this._saveGameModel = saveGameModel;

        this._isStartingNewGame = true;
    }

    execute(evt) {
        if (this._saveGameService.saveGameExists()) {
            if (this._saveGameService.saveGameVersionIsSynced()) {
                this._promptContinueOrRestart();
            } else {
                this._showUnsupportedSaveGameVersionNotice();
            }
        } else {
            this._isStartingNewGame = true;
            this._initializeAndStartScenario();
        }
    }

    _initializeAndStartScenario() {
        this.dispatch(ScenarioCommandEvent.INITIALIZE_SCENARIOS);
        this.dispatch(ScenarioCommandEvent.PLAY_SCENARIO);

        this.trackEvent(TrackString.EVENT_GAME_START, {
            new_game: this._isStartingNewGame,
        });

        this.trackEvent(TrackString.EVENT_SCREEN_STARTED, {
            screen_started: TrackScreenString.START_SCREEN
        });
    }

    _handleGameLoaded(evt) {
        this._dispatcher.removeEventListener(SaveGameEvent.GAME_LOADED, this._handleGameLoadedBound);
        this._initializeAndStartScenario();
    }

    _promptContinueOrRestart() {
        const systemMessage = new SystemMessageBuilder()
            .setTitle(this._languagePack.getText('restartOrContinuePrompt.title'))
            .setDescription(this._languagePack.getText('restartOrContinuePrompt.description'))
            .addOption({
                text: this._languagePack.getText('restartOrContinuePrompt.restartButtonLabel'),
                callback: () => {
                    this._saveGameService.clear();
                    this._initializeAndStartScenario();

                    this._isStartingNewGame = true;
                }
            })
            .addOption({
                text: this._languagePack.getText('restartOrContinuePrompt.continueButtonLabel'),
                callback: () => {
                    this._handleGameLoadedBound = this._handleGameLoaded.bind(this);
                    this._dispatcher.addEventListener(SaveGameEvent.GAME_LOADED, this._handleGameLoadedBound);
                    this._dispatcher.dispatch(SaveGameEvent.LOAD_GAME);

                    this._isStartingNewGame = false;
                }
            })
            .build();

        this.showSystemMessage(systemMessage);
    }

    _showUnsupportedSaveGameVersionNotice() {
        const systemMessage = new SystemMessageBuilder()
            .setTitle(this._languagePack.getText('unsupportedSaveGameVersionNotice.title'))
            .setDescription(this._languagePack.getText('unsupportedSaveGameVersionNotice.description'))
            .addOption({
                text: this._languagePack.getText('unsupportedSaveGameVersionNotice.okButtonLabel'),
                callback: () => {
                    this._saveGameService.clear();
                    this._initializeAndStartScenario();
                }
            })
            .build();

        this.showSystemMessage(systemMessage);
    }

}